module.exports = __webpack_public_path__ + "static/img/dango.d55046b.jpg";